import { render, staticRenderFns } from "./NetworkStudentMap.vue?vue&type=template&id=5485a5de"
import script from "./NetworkStudentMap.vue?vue&type=script&lang=js"
export * from "./NetworkStudentMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports